class UserModel {
  constructor(body, spkToken, userTokens = {}) {
    this.id = body.uid || body.id;
    this.email = body.email;
    this.firstname = body.firstname;
    this.lastname = body.surname;
    this.accountType = body.accountType;
    this.term = body.term;
    this.internalUser = body.internalUser;
    this.token = spkToken;
    this.userTokens = userTokens;
    this.isProUser = body.accountType === '100';
  }
}

export default UserModel;
